import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../packages/JsonQuery';

const trackRewardInstructionClick = (sc: TJsonQuery, modalStep: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Click',
    label: 'PopUpReward',
    sc,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        modal_step: modalStep,
      },
    },
    useLastProducts: true,
  });
};

export const trackRewardInstructionLinkClick = (sc: TJsonQuery) => {
  return trackRewardInstructionClick(sc, 'first');
};

export const trackRewardInstructionButtonClick = (sc: TJsonQuery) => {
  return trackRewardInstructionClick(sc, 'second');
};
